import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import axios from "axios";

const Dashboard = () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;  
  const branch_id = parseInt(localStorage.getItem("branch_id"), 10) || 1;

  const [isMaintenance, setIsMaintenance] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true; // ✅ Prevent duplicate state updates

    const checkMaintenanceStatus = async () => {
      try {
        const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
        const data = response.data.data || [];
        const dashboardStatus = data.find((item) => item.slug === "dashboard");

        if (isMounted) {
          setIsMaintenance(dashboardStatus?.maintenancemode_status === 1);
        }
      } catch (error) {
        console.error("Error checking maintenance mode:", error);
        if (isMounted) setIsMaintenance(false);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    checkMaintenanceStatus();

    return () => {
      isMounted = false; // ✅ Cleanup to prevent duplicate effects
    };
  }, [baseURL, branch_id]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh", width: "100vw" }}
      >
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (isMaintenance) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center text-center"
        style={{ height: "100vh", width: "100vw" }}
      >
        <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
        <p className="text-muted fs-5">
          The <strong>Dashboard</strong> module is currently under maintenance. <br />
          Please check back later.
        </p>
      </div>
    ); 
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-xl-8 col-xxl-7 text-center">
          <h3 className="mb-4">Welcome to the Dashboard 🎉</h3>
          <p>Your dashboard content goes here...</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
